module.exports = __webpack_public_path__ + "05_hige_black.3a88607b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer3/05_hige_black.png
// module id = 7K3g
// module chunks = 0